import { render, staticRenderFns } from "./Timetable.vue?vue&type=template&id=5b9507ab&scoped=true"
import script from "./Timetable.vue?vue&type=script&lang=js"
export * from "./Timetable.vue?vue&type=script&lang=js"
import style0 from "./Timetable.vue?vue&type=style&index=0&id=5b9507ab&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b9507ab",
  null
  
)

export default component.exports